var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofSwitchInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10Z",
    strokeWidth: 1.5,
    stroke: "#269C6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 9V14",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    stroke: "#269C6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 7.3C10.5523 7.3 11 6.85228 11 6.3C11 5.74772 10.5523 5.3 10 5.3C9.44772 5.3 9 5.74772 9 6.3C9 6.85228 9.44772 7.3 10 7.3Z",
    fill: "#269C6E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofSwitchInfo);
export default __webpack_public_path__ + "static/media/proof-switch-info.b22bad8bf90a5a443d5ac49016d00f68.svg";
export { ForwardRef as ReactComponent };